import { Reveal, Overline } from "./Reveal";
import { services } from "./data";

const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="max-w-2xl mb-14 md:mb-20">
        <Overline>What we do</Overline>
        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Electrical services, done properly
        </h2>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-600">
          From a single socket to a full rewire — clear advice, tidy work and
          no surprises on the bill.
        </p>
      </Reveal>

      <Reveal>
        <div
          data-testid="services-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-slate-200"
        >
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group border-r border-b border-slate-200 p-7 md:p-8 hover:bg-slate-50 transition-colors"
            >
              <div className="flex items-start justify-between">
                <s.icon className="w-7 h-7 text-blue-600" strokeWidth={1.75} />
                <span className="font-heading text-sm font-bold text-slate-300 group-hover:text-amber-500 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-6 text-lg font-bold text-slate-900">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{s.text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Services;
